import { get } from 'svelte/store';
import { mediaQueryStore } from './media_query.ts';

export function initDarkMode() {
  // const crumbStores = $page.data.crumbs.map((b) => b.store);
  // TODO: Move color scheme / theme code somewhere.
  const prefersDarkMode = mediaQueryStore('(prefers-color-scheme: dark)');
  let darkMode = get(prefersDarkMode);
  function toggleDarkMode() {
    // TODO: Cache in local storage
    darkMode = !darkMode;
    // TODO: Think about whether there's a better way to store these constants. They are only
    // literally available in the tailwind config which we don't have access to.
    // https://tailwindcss.com/docs/plugins
    document.documentElement.setAttribute('data-theme', darkMode ? 'darkMillies' : 'millies');
  }
  return { darkMode, toggleDarkMode };
}

export function getVar(varName: string, el?: HTMLElement) {
  return window.getComputedStyle(el ?? document.body).getPropertyValue(varName);
}
